import { useState, useEffect } from 'react'
import { useThrottledCallback } from 'use-debounce'

/*
    This hook adds `active` class to nav item, 
    if corresponding section is in view. 
*/
export const useSideNavHighlight = (title: string): void => {
  const mainNavLinks =
    typeof document !== `undefined`
      ? (document.querySelectorAll(
          '.sidebarNav a'
        ) as NodeListOf<HTMLAnchorElement>)
      : null

  const [updated, setUpdated] = useState<boolean>(false)

  function handleUserScroll() {
    // fromTop - top of scroll section
    // 200 - px value that includes the navbar and margin
    const fromTop = window.scrollY + 200
    mainNavLinks?.forEach(link => {
      const section =
        typeof document !== `undefined`
          ? (document.querySelector(link.hash) as HTMLAnchorElement)
          : null
      if (
        section &&
        section.offsetTop <= fromTop &&
        section.offsetTop + section.offsetHeight > fromTop
      ) {
        link.classList.add('menu-active')
        history.replaceState(null, title, link.hash)
      } else {
        link.classList.remove('menu-active')
      }
    })
  }
  const scrollHandler = useThrottledCallback(handleUserScroll, 250)

  useEffect(() => {
    // check if location has a hash, if not, add a hash
    if (!location.hash) {
      // update current url
      history.replaceState(null, title, '#section-1')
    }
    // update state
    setUpdated(true)
  }, [])

  useEffect(() => {
    window.addEventListener('scroll', scrollHandler)
    return () => {
      window.removeEventListener('scroll', handleUserScroll)
    }
  }, [updated])
}
